import React from 'react'

import { State } from './Store.types'

const initialState: State = {
    ...window.__APP_CONTAINER__,
    permissions: [],
    fullScreen: false,
    topHeader: true,
    sidebar: true,
    isOpenGoLive: false,
    goLiveFinished: false,
}

const nonSpaInitialState: State = {
    ...window.__APP_CONTAINER__,
    topHeader: true,
    sidebar: true,
    isOpenGoLive: false,
    goLiveFinished: false,
}

function reducer (state: State, action): State {
    switch (action.type) {
        case 'SET_PERMISSIONS':
            return {
                ...state,
                permissions: action.permissions
            }
        case 'SET_CAMPAIGN':
            return {
                ...state,
                campaign: action.campaign
            }
        case 'SET_CAMPAIGN_MENU':
            return {
                ...state,
                campaignMenu: {
                    ...state.campaignMenu,
                    campaignMenu: action.menu
                }
            }
        case 'SET_FULLSCREEN':
            return {
                ...state,
                fullScreen: action.fullScreen
            }
        case 'SET_TOP_HEADER':
            return {
                ...state,
                topHeader: action.show
            }
        case 'SET_SIDEBAR':
            return {
                ...state,
                sidebar: action.show
            }
        case 'OPEN_GO_LIVE_MODAL':
            return {
                ...state,
                isOpenGoLive: action.isOpenGoLive,
                goLiveFinished: false,
            }
        case 'GO_LIVE_FINISHED':
            return {
                ...state,
                goLiveFinished: action.goLiveFinished
            }
        default:
            return state
    }
}

export const Store = React.createContext<{ state: State, dispatch: React.Dispatch<unknown> } | undefined>(undefined) as React.Context<{ state: State, dispatch: React.Dispatch<unknown> }>

export function StoreProvider (props: { children: React.ReactNode }) {
    const [state, dispatch] = React.useReducer(reducer, initialState)
    const value = { state, dispatch }

    return <Store.Provider value={value}>{props.children}</Store.Provider>
}

export function NonSPAStoreProvider (props: { children: React.ReactNode }) {
    const [state, dispatch] = React.useReducer(reducer, nonSpaInitialState)
    const value = { state, dispatch }

    return <Store.Provider value={value}>{props.children}</Store.Provider>
}
